import request from '@/utils/request';
import {
  EntAccountBankInfo,
  EntAccountBonusInfo,
  EntAccountInfo,
  EntAccountPointConsumeItem,
  EntAccountPointStatistics,
  EntAccountPointStatisticsTimeLine,
  PackageBonusDetail,
  PlanPackageDetailInfo,
} from '@/interfaces/ent-account';
import { PaginationData, PaginationParams } from '@/interfaces/request';

export const getEntAccountInfo = () => {
  return request<EntAccountInfo>({ url: '/v1/ent-account/info', method: 'GET' });
};

export const getBonusInfo = () => {
  return request<EntAccountBonusInfo>({ url: '/v1/ent-account/bonus-info', method: 'GET' });
};

export const getPointStatistics = (params: { startAt: number; endAt: number }) => {
  return request<EntAccountPointStatistics>({
    url: '/v1/ent-account/statistics/only-point',
    method: 'GET',
    params,
  });
};

export const getStatisticsTimeLine = (data: {
  startAt: number;
  endAt: number;
  channel?: Record<string, (string | number)[]>;
}) => {
  return request<EntAccountPointStatisticsTimeLine[]>({
    url: '/v1/ent-account/statistics/timeline',
    method: 'POST',
    data,
  });
};

export const getPointConsumeStatistics = (
  data: PaginationParams<{
    cate: number;
    startAt: number;
    endAt: number;
    channel?: Record<string, (string | number)[]>;
  }>,
) => {
  return request<PaginationData<EntAccountPointConsumeItem>>({
    url: '/v1/ent-account/statistics/point-consume',
    method: 'POST',
    data,
  });
};

export const getEntAccountBankInfo = () => {
  return request<EntAccountBankInfo>({
    url: '/v1/ent-account/bank-info',
    method: 'GET',
  });
};

export const getPlanPackageDetailInfo = () => {
  return request<PlanPackageDetailInfo>({
    url: '/v1/ent-account/package-detail',
    method: 'GET',
  });
};

export const getPackageBonusDetail = () => {
  return request<PackageBonusDetail>({
    url: '/v1/ent-account/package-bonus-detail',
    method: 'GET',
  });
};
